import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'lookup-quick-select-panel',
    templateUrl: './quick-select-panel.component.html'
})

export class LookupQuickSelectPanelComponent implements OnInit {

    @Input() showMore = true;
    @Input() data: Array<any> = [];
    @Input() textField: string = '';
    @Input() formatter: (rowObj: any) => string;
    @Input() maxItems = 10;

    @Output() moreClcik = new EventEmitter();
    @Output() itemClick = new EventEmitter();

    @ViewChild('itemsContainer') itemsContainer: ElementRef<any>;

    activeIndex = -1;

    constructor(private injector: Injector, private cdr: ChangeDetectorRef) { }

    @HostListener('mousedown', ['$event'])
    onClick($event: MouseEvent) {
        $event.stopPropagation();
    }

    ngOnInit() { }

    loadData(items: any) {
        this.data = items;

        if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
        }
    }

    onMoreClick($event: MouseEvent) {
        $event.stopPropagation();
        this.moreClcik.emit($event);
    }

    formatData(rowObj: any) {
        return this.formatter(rowObj);
    }

    onItemClick($event, item) {
        this.itemClick.emit({data: item, evnet: $event});
    }

    setActiveItem(index: number) {
        this.activeIndex = index;
        if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
        }
    }
}